import { useEffect, useState } from "react";
import Load from "../../common/Loader/Load";
import { getUserInfo } from "../../service/getInfo";

const InfoMembership = () => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await getUserInfo();
        setUserData(data.info);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  if (!userData) {
    return <Load />;
  }

  const { afiliado1, afiliado2, contracto } = userData;
  const {
    membresia,
    contrato: contratoInfo,
    afiliados,
    beneficiarios,
    noches,
  } = contracto;

  return (
    <section className="section-account-payments">
      <h2 className="font-text">Mi cuenta</h2>
      <article className="info-user__details font-text">
        <div>
          <p>{afiliado1?.titular}</p>
          <p>{afiliado2?.titular}</p>
        </div>

        <div>
          <p>
            <span>Membresía:</span> {membresia}
          </p>
          <p>
            <span>Contrato:</span> {contratoInfo}
          </p>
        </div>

        <div>
          <p>
            <span>Afiliados:</span> {afiliados}
          </p>
          <p>
            <span>Beneficiarios:</span> {beneficiarios}
          </p>
        </div>

        <div>
          <p>
            <span>Noches por año:</span> {noches?.slice(0, 2) || 0} días por año
          </p>
        </div>
      </article>
    </section>
  );
};

export default InfoMembership;
